import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export async function exportExcelReport(data = []) {
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet("ข้อมูลลูกหนี้");

  ws.columns = [
    { header: "ลำดับ", key: "no", width: 8 },
    { header: "เลขสัญญา", key: "CONTNO", width: 18 },
    { header: "รายชื่อ", key: "name", width: 28 },
    { header: "รหัสบัตร", key: "CUSCOD", width: 20 },
    { header: "วันที่มอบงาน", key: "dateCeoInvestigate", width: 22 },
    { header: "หมายเหตุ", key: "remark", width: 45 },
    { header: "inv_id", key: "invId", width: 0 },
    { header: "loanId", key: "loanId", width: 0 },
  ];

  // จัดกลุ่มตาม CONTNO
  const grouped = data.reduce((m, row) => {
    const key = String(row?.CONTNO || "").trim();
    if (!key) return m;
    if (!m.has(key)) m.set(key, []);
    m.get(key).push(row);
    return m;
  }, new Map());

  Array.from(grouped.entries()).forEach(([contno, rows], groupIndex) => {
    rows.forEach((r, idxInGroup) => {
      const fullName = [r.SNAM, r.NAME1, r.NAME2]
        .filter(Boolean)
        .join("")
        .trim();

      const excelRow = ws.addRow({
        no: idxInGroup === 0 ? groupIndex + 1 : "",
        CONTNO: idxInGroup === 0 ? contno : "",
        name: fullName || "",
        CUSCOD: r.CUSCOD || "",
        dateCeoInvestigate: r.dateCeoInvestigate
          ? dayjs(r.dateCeoInvestigate).format("DD/MM/YYYY")
          : "-",
        remark: "",
        invId: r.invId ?? "",
        loanId: r.loanId,
      });

      excelRow.eachCell((cell) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // เส้นหนาบรรทัดแรกของแต่ละกลุ่ม
      if (idxInGroup === 0) {
        excelRow.eachCell((cell) => {
          excelRow.height = 14; // ✅ เพิ่มตรงนี้
          cell.border = {
            top: { style: "medium" },
            left: cell.border.left,
            bottom: cell.border.bottom,
            right: cell.border.right,
          };
        });
      }
    });
  });

  // Header style
  const header = ws.getRow(1);
  header.height = 20;
  header.eachCell((cell) => {
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEFEFEF" },
    };
    cell.border = {
      top: { style: "medium" },
      left: { style: "thin" },
      bottom: { style: "medium" },
      right: { style: "thin" },
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const dateLabel = data[0]?.dateCeoInvestigate
    ? dayjs(data[0].dateCeoInvestigate).format("DD_MM_YY")
    : dayjs().format("DD_MM_YY");

  saveAs(blob, `รีพอร์ตสืบทรัพย์_${dateLabel}.xlsx`);
}
